import { FC } from 'react';
import { CheckInstallationMessage } from './CheckInstallationMessage';

type CheckInstallationOperationListProps = {
  siteUrl: string;
};

export const CheckInstallationOperationList: FC<CheckInstallationOperationListProps> = ({ siteUrl }) => {
  return (
    <div>
      <CheckInstallationMessage text='what_to_do' />
      <ol className='list-inside list-decimal'>
        <CheckInstallationMessage text='install_snippet' asListItem />
        <CheckInstallationMessage text='open_site' translationValues={{ site: siteUrl }} asListItem />
        <CheckInstallationMessage text='once_triggered' asListItem />
      </ol>
    </div>
  );
};
